module.exports = __webpack_public_path__ + "static/gallery_west_street_2-1ca2c1de63edad53ead377c76368df05.jpg";